module.exports = __webpack_public_path__ + "static/media/project-5.dc381aad.jpg";